var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frame",attrs:{"id":"admin"}},[_vm._v("\n\tAdmin 预留入口\n")])}
var staticRenderFns = []

export { render, staticRenderFns }